var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.243 11.5794L19.5327 7.28972M19.5327 7.28972L15.243 3M19.5327 7.28972L4.00002 7.28959M8.28972 21.0003L4 16.7105M4 16.7105L8.28972 12.4208M4 16.7105L19.5327 16.7102",
    stroke: "currentColor",
    strokeWidth: 3.14019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeicon);
export default __webpack_public_path__ + "static/media/change.icon.670ece95f27339e0871aefc19fa93085.svg";
export { ForwardRef as ReactComponent };